<div *ngIf="this.data.form && this.seuilForm">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.data.form.get('id').value">Ajouter un CA1</h3>
      <h3 *ngIf="this.data.form.get('id').value">Modifier un CA1</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.data.form" style="display: flex; justify-content: space-between;">

        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" formControlName="code" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
                <mat-error *ngIf="form.get('code').hasError('maxLength')">
                  Nombre maximum de caractère dépassé
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            <mat-error *ngIf="form.get('libelle').hasError('maxLength')">
              Nombre maximum de caractère dépassé
            </mat-error>
            </mat-form-field>
        </div>
        
        <div class="col-sm-12">
          <app-autocomplete-with-code-form   
            name="site" [parent]="form"  
            libelle="Site" 
            [objets]="sites" 
            [(objet)]="site">
            </app-autocomplete-with-code-form>
        </div>

       
    </form>
    <form focusInvalidInput class="row" [formGroup]="this.seuilForm" style="display: flex; justify-content: space-between;">

    <div class="col-sm-6">
      <mat-form-field class="full-width">
      <mat-label>Seuil 1</mat-label>
      <input matInput name="seuil" type="number" formControlName="seuil1" required>
      <mat-error *ngIf="seuilForm.get('seuil1').hasError('required')">
          Veuillez saisir un seuil
      </mat-error>
      <mat-error *ngIf="seuilForm.get('seuil1').hasError('max') || seuilForm.get('seuil1').hasError('min')">
        Veuillez saisir un seuil inférieur au précédent et supérieur au suivant
      </mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="full-width">
      <mat-label>Seuil 2</mat-label>
      <input matInput name="seuil" type="number" formControlName="seuil2" required>
      <mat-error *ngIf="seuilForm.get('seuil2').hasError('required')">
          Veuillez saisir un seuil
      </mat-error>
      <mat-error *ngIf="seuilForm.get('seuil2').hasError('max') || seuilForm.get('seuil2').hasError('min')">
        Veuillez saisir un seuil inférieur au précédent et supérieur au suivant
      </mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="full-width">
      <mat-label>Seuil 3</mat-label>
      <input matInput name="seuil" type="number" formControlName="seuil3" required>
      <mat-error *ngIf="seuilForm.get('seuil3').hasError('required')">
          Veuillez saisir un seuil
      </mat-error>
      <mat-error *ngIf="seuilForm.get('seuil3').hasError('max') || seuilForm.get('seuil3').hasError('min')">
        Veuillez saisir un seuil inférieur au précédent et supérieur au suivant
      </mat-error>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
      <mat-form-field class="full-width">
      <mat-label>Seuil 4</mat-label>
      <input matInput name="seuil" type="number" formControlName="seuil4" required>
      <mat-error *ngIf="seuilForm.get('seuil4').hasError('required')">
          Veuillez saisir un seuil
      </mat-error>
      <mat-error *ngIf="seuilForm.get('seuil4').hasError('max') || seuilForm.get('seuil4').hasError('min')">
        Veuillez saisir un seuil inférieur au précédent et supérieur au suivant
      </mat-error>
      </mat-form-field>
    </div>
  </form>
</div>
  
<div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.data.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
</div>

